// extracted by mini-css-extract-plugin
export default {"container":"SuccessIcon_container__nyZvC","square":"SuccessIcon_square__lo87C","iconContainer":"SuccessIcon_iconContainer__ol8Zr"};